import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { of, switchMap } from 'rxjs';

import { FAIRS_CONFIGURATION, FairsConfiguration } from '../../interfaces/environment.interfaces';
import { DataAccessFairsFacade } from '../../states/fairs/entity/data-access-fairs.facade';

@Injectable({
  providedIn: 'root',
})
export class FairExistsGuard {
  constructor(
    private readonly router: Router,
    private readonly fairsFacade: DataAccessFairsFacade,
    @Inject(FAIRS_CONFIGURATION) private fairsConfiguration: FairsConfiguration
  ) {}

  canActivate(_: ActivatedRouteSnapshot, __: RouterStateSnapshot) {
    return this.fairsFacade.fairId$.pipe(
      switchMap((fairId) => {
        if (!Object.keys(this.fairsConfiguration.fairs).includes(fairId)) {
          return of(this.router.parseUrl(`/fairs`));
        }

        return of(true);
      })
    );
  }
}
